var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.refId,staticClass:"quark-element-wrapper",attrs:{"id":_vm.element.uuid},on:{"click":_vm.handleClick}},[_c(_vm.element.elName,_vm._b({ref:_vm.refChild,tag:"component",staticClass:"quark-element ani",attrs:{"uuid":_vm.element.uuid}},'component',_vm.element.propsValue,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }